export default {
      id: "european-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "icons.svg#european",
      toString: function () {
        return this.url;
      }
    }